// BEAM theme — barrel + assembled object. v1 "Blueprint".
// Import named tokens (`import { palette } from 'src/theme'`) or the whole theme
// (`import { theme } from 'src/theme'`).

export * from './colors';
export * from './typography';
export * from './layout';

import { palette, color, status } from './colors';
import { type as text, fontFamily } from './typography';
import { spacing, radius, shadow, layout, motion } from './layout';

export const theme = {
  palette,
  color,
  status,
  type: text,
  fontFamily,
  spacing,
  radius,
  shadow,
  layout,
  motion,
} as const;

export type Theme = typeof theme;
